/* unplugin-vue-components disabled */import script from "./TrafficManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficManager.vue?vue&type=script&setup=true&lang=js"

import "./TrafficManager.vue?vue&type=style&index=0&id=27bbf074&lang=scss"

const __exports__ = script;

export default __exports__